<template>
  <div>
    <base-title
      title="Google Ads"
      :subtitle="StringLanguage.integrations"
      link="integracoes"
    />

    <div class="integration-register">
      <div class="header">
        <div class="d-flex justify-between align-center w-100">
          <p class="title">Informações</p>
          <div class="toggle" @click="toggle()">
            <input type="checkbox" id="toggle-checkbox" v-model="toggleOn" />

            <div
              class="toggle-control"
              :class="toggleOn ? 'toggleOn' : 'toggleOff'"
            >
              <span class="control">
                <span>{{ toggleOn ? 'Ativado' : 'Desativado' }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="form">
        <base-input
          :valid="registerValid.id"
          placeholder="ID de conversão"
          class="w-100"
          v-model="id"
          @blur="validateId"
          @focus="registerValid.id = true"
        />

        <base-input
          placeholder="Rótulo de conversão"
          class="w-100"
          :valid="registerValid.label"
          v-model="label"
        />

        <div @click="save()" class="d-flex justify-end mt_20">
          <base-button text="Salvar" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/veasy/integrations.css';

import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseInput from '@/components/Input.vue';
import StoreAPI from '@/api/store';

export default {
  components: {
    BaseTitle,
    BaseButton,
    BaseInput,
  },
  data() {
    return {
      toggleOn: false,
      id: '',
      label: '',
      backRoute: 'google-ads',
      registerValid: {
        id: true,
        label: true,
      },
    };
  },
  async created() {
    const response = await StoreAPI.storeGetConfiguration();

    const configuration = response.getData([]);

    if (configuration.ads) {
      this.toggleOn = configuration.ads.active;
      this.id = configuration.ads.id;
      this.label = configuration.ads.label;
      this.backRoute = 'integracoes';
    }
  },
  methods: {
    toggle() {
      this.toggleOn = !this.toggleOn;
    },
    validateId() {
      if (this.id.startsWith('UA-')) {
        if (
          !(this.id.split('-')[1].length == 9) &&
          !(this.id.split('-')[1].length == 0)
        ) {
          this.registerValid.id = false;
          return;
        }
        this.registerValid.id = true;
        return;
      }
      this.registerValid.id = false;
    },
    async save() {
      if (this.id.length === 0 || !this.id) {
        this.registerValid.id = false;
        return;
      }

      if (this.label.length === 0 || !this.label) {
        this.registerValid.label = false;
        return;
      }

      const response = await StoreAPI.storeConfiguration({
        ads: {
          id: this.id,
          label: this.label,
          active: this.toggleOn,
        },
      });

      if (response.getErrors([]).length > 0) {
        this.registerValid.id = false;
        this.registerValid.label = false;

        alert('Ocorreu um error');
      }

      this.backRoute = 'integracoes';
    },
  },
};
</script>
